module.exports = __webpack_public_path__ + "img/38_5.7c3a56e5.png";